"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var constants = require("../../shared/code/Constants");
var PsqHelper_1 = require("../../shared/code/PsqHelper");
function viewSF() {
    var _this = this;
    return {
        constructor: function (props) {
            _this.state = {
                questionId: _this.props.question.questionId,
                value: _this.props.question.options[0].value,
                responseId: _this.props.question.options[0].responseId,
                constants: constants,
                questionText: PsqHelper_1.PsqHelper.getLabel(props.question),
            };
        },
        willReceiveProps: function (nextProps) {
            _this.state = {
                questionId: nextProps.question.questionId,
                value: nextProps.question.options[0].value,
                responseId: nextProps.question.options[0].responseId,
                constants: constants,
                questionText: PsqHelper_1.PsqHelper.getLabel(nextProps.question),
            };
        },
        mounted: function () {
        },
        events: {
            onChange: function (value, id) {
                _this.props.onChange(value, _this.state.questionId, _this.state.responseId);
            }
        }
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/PSQFreeFormEssay/ViewSF.js
// module id = 713
// module chunks = 0